import type { Platform, ShareContent } from '../types';
import { PlatformRegistry } from './registry';

/** Check if the user is on a mobile device */
function isMobile(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const instagram: Platform = {
  id: 'instagram',
  name: 'Instagram',
  iconIndex: PlatformRegistry.instagram.index,
  color: PlatformRegistry.instagram.color,
  buildUrl: (_content: ShareContent): string => {
    if (isMobile()) {
      return 'instagram://app';
    }
    return 'https://www.instagram.com/';
  },
};

